import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Text from 'components/Text';
import Stack from 'components/Stack';
import BulletList from 'components/BulletList';
import SimpleModal from 'components/SimpleModal';
function ContentContributionsModal(_ref) {
  var onClose = _ref.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(SimpleModal, {
    title: t('modal_allow_content_contribution_title'),
    body: /*#__PURE__*/React.createElement(Stack, {
      spacing: "m"
    }, /*#__PURE__*/React.createElement(Text, {
      as: "p"
    }, t('modal_allow_content_contribution_intro')), /*#__PURE__*/React.createElement(Trans, {
      t: t,
      i18nKey: "modal_allow_content_contribution_abilities_included_subheading"
    }, "The option \u201CAllow everyone in audience to add and edit their own assets\u201D will give everyone with access to the playlist these", ' ', /*#__PURE__*/React.createElement("strong", null, "basic content contribution abilities:")), /*#__PURE__*/React.createElement(BulletList, null, /*#__PURE__*/React.createElement(React.Fragment, null, t('modal_allow_content_contribution_abilities_included_upload_files')), /*#__PURE__*/React.createElement(React.Fragment, null, t('modal_allow_content_contribution_abilities_included_edit_delete_content')), /*#__PURE__*/React.createElement(React.Fragment, null, t('modal_allow_content_contribution_abilities_included_reorder_content'))), /*#__PURE__*/React.createElement(Text, {
      bold: true,
      as: "p"
    }, t('modal_allow_content_contribution_abilities_excluded_subheading')), /*#__PURE__*/React.createElement(BulletList, null, /*#__PURE__*/React.createElement(React.Fragment, null, t('modal_allow_content_contribution_abilities_excluded_edit_name')), /*#__PURE__*/React.createElement(React.Fragment, null, t('modal_allow_content_contribution_abilities_excluded_edit_delete_content')), /*#__PURE__*/React.createElement(React.Fragment, null, t('modal_allow_content_contribution_abilities_excluded_add_sections')), /*#__PURE__*/React.createElement(React.Fragment, null, t('modal_allow_content_contribution_abilities_excluded_view_analytics')))),
    buttons: [{
      label: t('actions_got_it'),
      onClick: onClose
    }],
    onClose: onClose
  });
}
export default ContentContributionsModal;